var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25781 1.59961C3.15801 1.59961 2.25781 2.4998 2.25781 3.59961V16.3996C2.25781 17.4994 3.15801 18.3996 4.25781 18.3996H17.0578C18.1576 18.3996 19.0578 17.4994 19.0578 16.3996V3.59961C19.0578 2.4998 18.1576 1.59961 17.0578 1.59961H4.25781ZM4.25781 2.39961H17.0578C17.7252 2.39961 18.2578 2.93222 18.2578 3.59961V16.3996C18.2578 17.067 17.7252 17.5996 17.0578 17.5996H4.25781C3.59042 17.5996 3.05781 17.067 3.05781 16.3996V3.59961C3.05781 2.93222 3.59042 2.39961 4.25781 2.39961ZM7.45781 4.88633V15.1129L8.06641 14.741L15.825 9.99961L7.45781 4.88633ZM8.25781 6.31289L14.2906 9.99961L8.25781 13.6863V6.31289Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTime);
export default __webpack_public_path__ + "static/media/StartTime.17770fff442fc97f7c3e846c6fe59d76.svg";
export { ForwardRef as ReactComponent };